<template>
  <v-btn
    outlined
    tile
    :disabled="isCalculating"
    :loading="isCalculating"
    @click="validate"
  >
    {{ `${numberOfResults} ` }}
    {{ $tc('search.filter.display-results', numberOfResults) }}
  </v-btn>
</template>

<script>
  export default {
    name: 'SearchValidateButton',

    props: {
      isCalculating: {
        required: true,
        type: Boolean,
      },

      numberOfResults: {
        required: true,
        type: Number,
      },
    },

    methods: {
      validate() {
        this.$emit('validate')
      },
    },
  }
</script>

<style lang="sass" scoped>
  @import "@/assets/styles/_config.sass"
  @import "@/assets/styles/_mixins.sass"

  .v-btn
    @include basic-btn
    background-color: #fff !important
    color: $primary-color
    margin-top: 10px
    width: 100%
    cursor: pointer

  .v-progress-circular
    margin-right: 10px

  .v-application .red--text
    color: $primary-color

  .theme--light.v-btn.v-btn--disabled
    color: $primary-color !important
    cursor: not-allowed !important
</style>
